<h2 class="default-dialog-header" mat-dialog-title style="font-weight: normal">
	<span fxFlex>Check Capacity</span>
	<span fxFlex fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog(null)" class="primary-light-color cursor-pointer"
			>close</mat-icon
		>
	</span>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content">
	<div class="p-8" fxLayout="row">
		<div class="full-width">
			<div class="f-s-w-500 primary-text" fxFlex="50">
				<span>Origin:</span>
			</div>
			<div class="f-s" fxFlex="50" fxLayoutAlign="center center">
				<div>
					{{data.projectDTO.originCity + ', ' + data.projectDTO.originState + ' ' +
					data.projectDTO.originZip}}
				</div>
			</div>
		</div>
	</div>

	<div class="p-8" fxLayout="row">
		<div class="full-width">
			<div class="f-s-w-500 primary-text" fxFlex="50">
				<span>Destination:</span>
			</div>
			<div class="f-s" fxFlex="50" fxLayoutAlign="center center">
				<div>
					{{data.projectDTO.destCity + ', ' + data.projectDTO.destState + ' ' +
					data.projectDTO.destZip}}
				</div>
			</div>
		</div>
	</div>

	<div class="p-8" fxLayout="row">
		<div class="full-width">
			<div class="f-s-w-500 primary-text" fxFlex="50">
				<span>Trailer Type:</span>
			</div>
			<div class="f-s" fxFlex="50" fxLayoutAlign="center center">
				<div>{{data.projectDTO.equipmentType}}</div>
			</div>
		</div>
	</div>

	<div class="p-8" fxLayout="row">
		<div class="full-width">
			<div class="f-s-w-500 primary-text" fxFlex="50">
				<span>Weight (lbs):</span>
			</div>
			<div class="f-s" fxFlex="50" fxLayoutAlign="center center">
				<div>{{data.projectDTO.weight}}</div>
			</div>
		</div>
	</div>

	<div class="p-8" fxLayout="row">
		<div class="full-width">
			<div class="f-s-w-500 primary-text" fxFlex="50">
				<span>Commodity:</span>
			</div>
			<div class="f-s" fxFlex="50" fxLayoutAlign="center center">
				<div>{{IS_NOT_EMPTY(data.projectDTO.commodity) ? data.projectDTO.commodity : '-'}}</div>
			</div>
		</div>
	</div>

	<div class="p-8" fxLayout="row">
		<div class="full-width">
			<div class="f-s-w-500 primary-text" fxFlex="50">
				<div class="h-100" fxLayoutAlign="start end">Volume:</div>
			</div>
			<div class="f-s" fxFlex="50" fxLayoutAlign="center center">
				<div
					*ngIf="!accountSettings.ANNUAL_VOLUME || isEditingAnnualVolume"
					fxLayout="row"
					fxLayoutAlign="start end"
					fxLayoutGap="0.2rem"
				>
					<mat-form-field class="custom-form-field" floatLabel="never" fxFlex>
						<mat-label>Duration</mat-label>
						<mat-select
							(selectionChange)="setAnnualVolumeDisplay()"
							[(ngModel)]="data.projectDTO.loadVolumeDuration"
							disableOptionCentering
						>
							<mat-option *ngFor="let duration of loadVolumeDuration" [value]="duration">
								{{ duration }}
							</mat-option>
						</mat-select>
					</mat-form-field>
					<mat-form-field class="custom-form-field" floatLabel="never" fxFlex="35">
						<mat-label>Count</mat-label>
						<input
							(input)="setAnnualVolumeDisplay()"
							[(ngModel)]="data.projectDTO.loadVolume"
							autocomplete="off"
							floatLabel="never"
							fxFlex
							mask="separator"
							thousandSeparator=","
							matInput
						/>
					</mat-form-field>
					<mat-icon
						(click)="isEditingAnnualVolume = false;"
						*ngIf="isEditingAnnualVolume"
						[inline]="true"
						class="danger-text cursor-pointer"
						matSuffix
					>
						cancel
					</mat-icon>
				</div>

				<div
					*ngIf="accountSettings.ANNUAL_VOLUME && !isEditingAnnualVolume"
					class="h-100"
					fxLayout="row"
					fxLayoutAlign="end center"
					fxLayoutGap="0.2rem"
				>
					{{ANNUAL_VOLUME_DISPLAY}}
					<mat-icon
						(click)="isEditingAnnualVolume = true;"
						[inline]="true"
						class="primary-text m-l-1 cursor-pointer edit-volume"
						matSuffix
					>
						edit
					</mat-icon>
				</div>
			</div>
		</div>
	</div>

	<div class="p-8" fxLayout="row">
		<div class="full-width">
			<div class="f-s-w-500 primary-text" fxFlex="50">
				<span>Trailer Requirements:</span>
			</div>
			<div class="f-s" fxFlex="50" fxLayoutAlign="center center">
				<div>
					{{IS_NOT_EMPTY(data.projectDTO.trailerRequirements) ? data.projectDTO.trailerRequirements
					: '-'}}
				</div>
			</div>
		</div>
	</div>

	<div class="p-8" fxLayout="row">
		<div class="full-width">
			<div class="f-s-w-500 primary-text" fxFlex="50">
				<span>Packaging:</span>
			</div>
			<div class="f-s" fxFlex="50" fxLayoutAlign="center center">
				<div>{{IS_NOT_EMPTY(data.projectDTO.packaging) ? data.projectDTO.packaging : '-'}}</div>
			</div>
		</div>
	</div>
</mat-dialog-content>
<mat-divider></mat-divider>

<mat-dialog-actions class="default-dialog-action">
	<div fxFlex="100" fxLayoutAlign="end center" fxLayoutGap="1rem">
		<a (click)="closeDialog(null)"
			><span class="primary-text text-underline cursor-pointer">Cancel</span></a
		>
		<button
			(click)="sendEmailToCarriers()"
			*ngIf="!isRequestInProgress"
			color="primary"
			mat-raised-button
		>
			Email Carriers
		</button>
		<mat-spinner *ngIf="isRequestInProgress" [diameter]="30"></mat-spinner>
	</div>
</mat-dialog-actions>
